<template>
  <div id="scroll-board">
    <dv-border-box-10 class="catdsBox1">
      <div class="boxBorder1">
        <dv-border-box-8
          class="dvBox"
          :class="`${item.id === 1 ? 'widthItem' : ''}`"
          v-for="item in inventory"
          :key="item.id"
        >
          <div class="fileBox">
            <div>
              <div class="decorationBox">
                <div class="title">{{ item.title }}</div>
                <dv-decoration-5
                  class="decoration5"
                  style="width: 160px; height: 30px"
                />
              </div>
              <div class="invetBox">
                <div
                  class="itemList"
                  v-for="accessItem in item.access"
                  :key="accessItem.id"
                >
                  <div class="accessTitle">{{ accessItem.title }}</div>
                  <div class="num">
                    <dv-digital-flop
                      :config="accessItem.number"
                      style="width: 80px; height: 20px"
                      ref="scrollBoard"
                    />
                    <div class="unit1">{{ accessItem.unit }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="invenWarBox">
              <dv-scroll-board
                class="invenWar"
                :config="item.invenitem"
                style="width: 100%; height: 100%"
              />
            </div>
          </div>
        </dv-border-box-8>
      </div>
    </dv-border-box-10>
  </div>
</template>

<script>
export default {
  name: 'inventory',
  props: {
    countData: {
      type: Object,
      default: function () {
        return {
          total: {
            employeeCount: 0,
            departmentCount: 0,
            processCount: 0,
            productCount: 0,
            taskCount: 0,
            completedCount: 0,
            smartDeviceCount: 0,
            rawMaterialCount: 0,
            videoCount: 0
          },
          rawMaterialStatistics: [],
          packageRawMaterialStatistics: [],
          packageRawMaterialStockCount: 0,
          packageRawMaterialInCount: 0,
          packageRawMaterialOutCount: 0,
          productStatistics: [],
          productStockCount: 0,
          productTodayInCount: 0,
          productTodayOutCount: 0,
          productionDepartmentStatistics: []
        }
      },
      require: true
    }
  },
  computed: {
    inventory: function () {
      const { randomExtend } = this
      var rawMaterialdList = this.countData.rawMaterialStatistics.map((x) => {
        if (x.isAlert) {
          return [
            `<span style="color:#f46827; font-weight:700;">${x.name}</span>`,
            `<span style="color:#f46827;font-weight:700;">${x.stock}</span>`
          ]
        } else {
          return [x.name, x.stock]
        }
      })

      var packageRawMaterialList =
        this.countData.packageRawMaterialStatistics.map((x) => {
          if (x.isAlert) {
            return [
              `<span style="color:#f46827; font-weight:700;">${x.name}</span>`,
              `<span style="color:#f46827; font-weight:700;">${x.todayInCount}</span>`,
              `<span style="color:#f46827; font-weight:700;">${x.todayOutCount}</span>`,
              `<span style="color:#f46827;font-weight:700;">${x.stock}</span>`
            ]
          } else {
            return [x.name, x.todayInCount, -x.todayOutCount, x.stock]
          }
        })

      function compareNumbers(a, b) {
        return b.todayInCount - a.todayInCount
      }

      var productStatistics = this.countData.productStatistics
        .sort(compareNumbers)
        .map((x) => {
          return [
            x.name,
            x.todayInCount,
            -x.todayOutCount,
            this.randomExtend(100, 1000)
          ]
        });

      return [
        {
          id: 1,
          title: '原材料库存',
          invenitem: {
            header: ['名称', '库存'],
            data: rawMaterialdList,
            columnWidth: [150, 70],
            align: 'right',
            rowNum: 13,
            waitTime: 7000,
            headerBGC: 'rgba(255,255,255,0.2)',
            oddRowBGC: 'rgba(255, 255, 255, 0.1)',
            evenRowBGC: 'rgba(0, 0, 0,0.1)'
          }
        },
        {
          id: 2,
          title: '纸箱库存',
          access: [
            {
              id: 1,
              title: '累计入库',
              iconfont: '',
              number: {
                number: [this.countData.packageRawMaterialInCount],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#4d99fc',
                  fontWeight: 'bold',
                  fontSize: 17
                }
              },
              unit: '件'
            },
            {
              id: 2,
              title: '累计出库',
              iconfont: '',
              number: {
                number: [this.countData.packageRawMaterialOutCount],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#f46827',
                  fontWeight: 'bold',
                  fontSize: 17
                }
              },
              unit: '件'
            },
            {
              id: 3,
              title: '剩余库存',
              iconfont: '',
              number: {
                number: [
                  this.countData.packageRawMaterialInCount -
                    this.countData.packageRawMaterialOutCount
                ],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#40faee',
                  fontWeight: 'bold',
                  fontSize: 17
                }
              },
              unit: '件'
            }
          ],
          invenitem: {
            header: ['名称', '当日入库', '当日出库', '剩余库存'],
            data: packageRawMaterialList,
            columnWidth: [120, 80, 80, 80],
            rowNum: 10,
            waitTime: 7000,
            headerBGC: 'rgba(255,255,255,0.2)',
            oddRowBGC: 'rgba(255, 255, 255, 0.1)',
            evenRowBGC: 'rgba(0, 0, 0,0.1)'
          }
        },
        {
          id: 3,
          title: '产品库存',
          access: [
            {
              id: 1,
              title: '累计入库',
              iconfont: '',
              number: {
                number: [this.countData.productTodayInCount],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#4d99fc',
                  fontWeight: 'bold',
                  fontSize: 17
                }
              },
              unit: '件'
            },
            {
              id: 2,
              title: '累计出库',
              iconfont: '',
              number: {
                number: [this.countData.productTodayInCount - this.countData.productStockCount],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#f46827',
                  fontWeight: 'bold',
                  fontSize: 17
                }
              },
              unit: '件'
            },
            {
              id: 3,
              title: '剩余库存',
              iconfont: '',
              number: {
                number: [this.countData.productStockCount],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#40faee',
                  fontWeight: 'bold',
                  fontSize: 17
                }
              },
              unit: '件'
            }
          ],
          invenitem: {
            header: ['名称', '当日入库', '当日出库', '剩余库存'],
            data: productStatistics,
            columnWidth: [120, 80, 80, 80],
            rowNum: 10,
            waitTime: 7000,
            headerBGC: 'rgba(255,255,255,0.2)',
            oddRowBGC: 'rgba(255, 255, 255, 0.1)',
            evenRowBGC: 'rgba(0, 0, 0,0.1)'
          }
        }
      ]
    }
  },
  data() {
    return {
      //inventory: []
    }
  },
  created() {
    // this.inventory = testInventory.inventory
  },
  mounted() {
    const { createData } = this
    createData()
    setInterval(this.createData, 30000)
  },
  methods: {
    createData() {
      const { randomExtend } = this
      //this.inventory =
    },
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10)
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      }
    }
  }
}
</script>

<style lang="less">
#scroll-board {
  width: 70%;
  margin-left: 15px;
  .catdsBox1 {
    .boxBorder1 {
      height: 100%;
      box-sizing: border-box;
      padding: 10px 10px;
      display: flex;
      justify-content: space-between;
    }
  }
  .dvBox {
    height: 100%;
    width: 360px;
    box-sizing: border-box;
    margin-right: 10px;
    .fileBox {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .invetBox {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        .itemList {
          width: 100px;
          padding: 6px;
          border-radius: 6px;
          background-color: rgba(6, 30, 93, 0.5);
          border-right: 3px solid rgb(6, 30, 93);
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-left: 10px;
          .accessTitle {
            font-weight: 700;
            font-size: 15px;
          }
          .num {
            margin-left: -50%;
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 15px;

            .unit1 {
              font-size: 13px;
            }
          }
        }
      }
      .invenWarBox {
        height: 100%;
      }
    }
    .decorationBox {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .title {
      font-size: 18px;
      font-weight: 700;
      margin-top: 8px;
    }
    .decoration5 {
      margin-top: -10px;
    }
  }
  .widthItem {
    width: 220px;
  }
}
</style>
